import styled from 'styled-components';

export const PaperWarning = styled.p`
  color: var(--cvna-color-grey-5);
  font-size: 16px;
  font-weight: 390;
  margin: 0;

  a {
    color: var(--cvna-color-blue-2);
    font-weight: 400;
  }
`;

export const DocumentTitle = styled.div`
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: -8px;

  h4 {
    margin: 0;
    font-size: 16px;
    font-weight: 450;
    color: var(--cvna-color-blue-6);
  }
`;
